import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Shared search field: rounded input with the magnifier / clear icon *inside*
 * the field (nbSuffix), the pattern used across the app. Extracted so the five
 * hand-rolled copies (agents overview, KB page x2, agent access tab, KB dialog)
 * can't drift apart again — one of them had the icon rendering above the field.
 *
 * Two-way bindable: `[(value)]="search"`. `valueChange` also fires the caller's
 * filter/reset logic; `(cleared)` is a convenience for the clear button.
 */
@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.scss',
})
export class SearchInputComponent {
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();

  /** i18n key for the placeholder. Defaults to the app-wide "Suchen…". */
  @Input() placeholderKey = 'menu.searchPlaceholder';

  onInput(v: string): void {
    this.value = v;
    this.valueChange.emit(v);
  }

  clear(): void {
    this.value = '';
    this.valueChange.emit('');
  }
}
